var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.blockClasses},[_vm._v("\n    Default field\n")])}
var staticRenderFns = []

export { render, staticRenderFns }